//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherPayrollSettingsDisplayItem } from './TeacherPayrollSettingsDisplayItem';
import { EventColorEnum, BillingProfileDefaultMode } from './Enums';

export class TeacherPrivilegesAndSettingsDisplayItem extends ItemBase {
    CanEditExpensesAndRevenue: boolean = false;
    CanEditInvoicesAndAccounts: boolean = false;
    CanEditMileage: boolean = false;
    CanEditOtherTeacherSchedulesAndStudents: boolean = false;
    CanEditOwnSchedule: boolean = false;
    CanEditReports: boolean = false;
    CanEditSharedOnlineResources: boolean = false;
    CanEditWebsiteAndPostNews: boolean = false;
    CanRecordPaymentWithAttendance: boolean = false;
    CanTakeAttendance: boolean = false;
    CanViewOtherTeacherSchedules: boolean = false;
    CanViewOtherTeacherContactInformation: boolean = false;
    CanViewOwnPayroll: boolean = false;
    CanViewStudentAndParentAddressAndTelephone: boolean = false;
    CanViewStudentAndParentEmailAddresses: boolean = false;
    CanViewStudentAttachments: boolean = false;
    IsActive: boolean = false;     // OBSOLETE - Use only for compatibility
    IsAdministrator: boolean = false;
    IsTeacher: boolean = false;     // OBSOLETE - Use only for compatibility
    ColorOnCalendar: EventColorEnum = EventColorEnum.Beach;
    PreferredLessonEventLocationID: string | null = null;
    ShowInSignUpDropDown: boolean = false;
    DefaultBillingMode: BillingProfileDefaultMode = BillingProfileDefaultMode.None;
    DefaultEventCategoryID: string | null = null;
    DefaultLessonDuration: number = 0;
    DefaultLessonPrice: number = 0;
    BookingPriority: number = 0;
    PayrollSettings: TeacherPayrollSettingsDisplayItem | null = null;

    constructor(initializer?: Partial<TeacherPrivilegesAndSettingsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherPrivilegesAndSettingsDisplayItem";
}
